import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import colors from "@digits-shared/themes/colors"
import styled, { css } from "styled-components"

export const titleIconStyles = css`
  width: 24px;
  height: 24px;
  ${svgPathStyles(colors.secondary, 1.5)};
`

export const IconContainer = styled.div`
  width: 42px;
  height: 42px;
  border: 2px solid ${colors.secondary};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`
